import { render, staticRenderFns } from "./myTeaBalance.vue?vue&type=template&id=acf28036&scoped=true"
import script from "./myTeaBalance.vue?vue&type=script&lang=js"
export * from "./myTeaBalance.vue?vue&type=script&lang=js"
import style0 from "./myTeaBalance.vue?vue&type=style&index=0&id=acf28036&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acf28036",
  null
  
)

export default component.exports